export default "__VITE_ASSET__Db$vW5DI__"